import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const detectDefault = () => {
    const stored = localStorage.getItem("overlast-lang");
    if (stored === "en" || stored === "hu") return stored;
    return navigator.language?.toLowerCase().startsWith("hu") ? "hu" : "en";
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(detectDefault);

    useEffect(() => {
        localStorage.setItem("overlast-lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
